import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useDispatch } from "react-redux";

import { Strings } from "@app/constants";
import { deleteAssignCustomers } from "../slice";

interface DeleteCustomerPopupProps {
  open: boolean;
  onClose: () => void;
  customerId: number;
  userDetailsId: number;
}

const DeleteCustomerPopup: React.FC<DeleteCustomerPopupProps> = ({
  open,
  onClose,
  customerId,
  userDetailsId,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDelete = () => {
    if (customerId) {
      dispatch(
        deleteAssignCustomers({ customerId: customerId, userId: userDetailsId })
      );
    }
  };

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ mt: 2, textAlign: "center" }}>
        <img
          src="./assets/images/delete-customer.png"
          alt=""
          style={{
            width: 40,
            height: 40,
            objectFit: "contain",
          }}
        />
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#101828" }}
        >
          {Strings.salesPerson.deleteAssignedCustomer}
        </Typography>
        <Typography sx={{ color: "#344054" }}>
          {Strings.salesPerson.areYouSure}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: fullScreen ? "center" : "flex-end",
          mb: 2,
          flexDirection: fullScreen ? "column" : "row",
          gap: fullScreen ? 1.5 : 0,
          px: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          fullWidth={fullScreen}
          sx={{
            color: "#025363",
            border: "none",
            textTransform: "none",
            fontWeight: "600",
            fontFamily: fontFamily,
          }}
        >
          {Strings.button.cancel}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          fullWidth={fullScreen}
          sx={{
            width: fullScreen ? "100%" : "28%",
            borderRadius: 0.5,
            backgroundColor: "#D92D20",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#B42318",
            },
          }}
        >
          {Strings.button.delete}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { DeleteCustomerPopup };
